export default "__VITE_ASSET__cyOT$VLJ__"